import { fetcher } from '@commenda/utils';
import {
  AM_TP_DEMO_ROUTES,
  TAmDemoResult,
  TAmDemoSaveTemplateRequest,
  TAmDemoSaveTemplateResponse,
} from './types';

/**
 * Saves the parsed document as a reusable template, with its version and placeholder mappings.
 *
 * The template is real, so it appears in the picker on a second run. Call `useInvalidateAmTpDemo()` afterwards
 * so the template library shows it without a refresh.
 */
export async function saveAmTpDemoTemplate(
  body: TAmDemoSaveTemplateRequest
): Promise<TAmDemoResult<TAmDemoSaveTemplateResponse>> {
  try {
    const response = await fetcher(AM_TP_DEMO_ROUTES.saveTemplate, {
      method: 'POST',
      body,
    });

    if (!response.ok) {
      return { success: false, error: 'Failed to save the template' };
    }

    return {
      success: true,
      data: (await response.json()) as TAmDemoSaveTemplateResponse,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Failed to save the template',
    };
  }
}
